module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The ideas expressed in this book have been forming for a lifetime. I’m therefore indebted to many more people than I can name.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Of those I shall name, my late parents are first. My mother, Regina, was a feisty English teacher; my father, Leo, a thoughtful economist. It’s no wonder I’ve pursued careers in journalism and business, and am now writing about economics. I owe my passion and grammar to one, my inquisitiveness and logic to the other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My partner, Cornelia Durrant, made this book happen. Many of the keenest insights, when not Smokey’s, were hers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My editor, Johanna Vondeling, understood this book from the beginning, and kept it on track. Thanks also to Steve Piersanti and the entire BK staff, and to John de Graaf for introducing me to BK.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Seth Zuckerman wrestled clarity from an unruly draft. Without him I would not have met my deadline. I’m also extremely grateful to the Rockefeller Foundation, which provided a much-needed retreat for writing in Bellagio, Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My fellow Fellows at the Tomales Bay Institute—Jonathan Rowe and David Bollier, in particular—were a constant source of ideas and encouragement. So, whether they knew it or not, were Dean Baker, Harriet Barlow, Connie Best, James Boyce, Rachel Breen, Marc Breslow, Peter Brown, Chuck Collins, Chris Desser, Peter Dorman, Brett Frischmann, Robert Glennon, Charles Halpern, Ann Hancock, Lewis Hyde, Marjorie Kelly, George Lakoff, Frances and Anna Lappé, Kathleen Maloney, Neil Mendenhall, David Morris, Richard Norgaard, Matt Pawa, Carolyn Raffensperger, Julie Ristau, Mark Sommer, Allen White, Bob Wilkinson, Susan Witt, and Oran Young.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _vm._v("Others whose writings have influenced me include E. F. Schumacher, Herman Daly, John Maynard Keynes, John Kenneth Galbraith, Ronald Coase, Louis Kelso, and Henry George.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This entire undertaking would not have been possible without the love and support of my entire family, especially Eli and Zack. Thank you so much.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c560b8e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ack.vue
// module id = 81
// module chunks = 0